Ember.Handlebars.registerHelper('if-advanced-user', function(options) {
    if (this.container.lookup('controller:user').get('hasStaffPermissions')) {
        return options.fn(this)
    } else {
        return options.inverse(this)
    }
})
